/**
 * The component that allows saving of mobile number and log out.
 */

/**
 * TODO: Implement save mobile number API and handle form states.
 */

import {
  Heading,
  Link as ChakraLink,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  VStack,
} from "@chakra-ui/react";
import { useGetUserProfileQuery } from "queries";
import { Link } from "react-router-dom";
import { ModalTypes } from "../../../config/types/modals";
import useAuth from "../../../hooks/useAuth";
import { SecondaryButton } from "../atoms/HJSButton";

interface IModalComponentProps {
  changeModalType: (modalType: ModalTypes) => void;
  onClose: () => void;
}
type TModalComponent = (props: IModalComponentProps) => JSX.Element;

const UserProfile: TModalComponent = ({
  changeModalType,
  onClose,
}: IModalComponentProps) => {
  const { logout, userDetails, isAuthenticated } = useAuth();

  const handleLogout: () => void = () => {
    logout();
    onClose();
    changeModalType(ModalTypes.LOGIN);
  };

  const verificationModalHandler = (): void => {
    changeModalType(ModalTypes.VERIFICATION_CODE);
  };

  return (
    <ModalContent>
      <ModalHeader>
        <Heading
          as="h2"
          textAlign="center"
          fontSize={[28, 28, 35, 40]}
          color="teal.900"
        >
          {userDetails?.name}
        </Heading>
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <VStack w="full" my={{ base: 4, md: 10 }} spacing={6} px={4}>
          {(userDetails as boolean) &&
            isAuthenticated &&
            userDetails?.is_email_verified === false && (
              <SecondaryButton
                w="full"
                onClick={verificationModalHandler}
                fontSize={[12, 12, 18, 24]}
              >
                Complete Verification
              </SecondaryButton>
            )}
          {isAuthenticated && (userDetails?.is_email_verified as boolean) && (
            <SecondaryButton
              w="full"
              onClick={() => changeModalType(ModalTypes.PHONE_NUMBER)}
              fontSize={[12, 12, 18, 24]}
            >
              {(userDetails?.phone as boolean) ? "Update" : "Save"} Mobile
              Number
            </SecondaryButton>
          )}
          <SecondaryButton
            w="full"
            onClick={handleLogout}
            fontSize={[12, 12, 18, 24]}
          >
            Log Out
          </SecondaryButton>
        </VStack>
      </ModalBody>
      <ModalFooter alignItems="center" justifyContent="center">
        <VStack my={4} spacing={4}>
          <ChakraLink
            href="mailto: support@helpingjobseekers.org"
            fontWeight="400"
            color="hjsBlack"
          >
            Need Help? Contact us
          </ChakraLink>
        </VStack>
      </ModalFooter>
    </ModalContent>
  );
};

export default UserProfile;
